import { render, staticRenderFns } from "./DistributorCatalogs.vue?vue&type=template&id=3c0e16ec"
import script from "./DistributorCatalogs.vue?vue&type=script&lang=js"
export * from "./DistributorCatalogs.vue?vue&type=script&lang=js"
import style0 from "./DistributorCatalogs.vue?vue&type=style&index=0&id=3c0e16ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports